import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const HOMEPAGE_PATHS = [
  '/',
  '/nomad-insurance',
  '/nomad-insurance/',
  '/nomad-health',
  '/nomad-health/'
];

const useLocationChange = () => {
  const location = useLocation();

  const getCurrentProduct = ({ pathname }) => {
    if (pathname.startsWith('/nomad-health')) {
      return 'nomad-health';
    }

    if (pathname.startsWith('/nomad-insurance') || pathname.startsWith('/nomads')) {
      return 'nomad-insurance';
    }

    return 'global';
  };

  const homepage = ({ pathname }) => {
    return HOMEPAGE_PATHS.includes(pathname);
  };

  const faqPage = ({ pathname }) => {
    return HOMEPAGE_PATHS.map((item) => `${item}/faq`)
      .concat(HOMEPAGE_PATHS.map((item) => `${item}/faq/`))
      .includes(pathname);
  };

  const [product, setProduct] = useState({
    isNomadHealth: false,
    isNomadInsurance: false,
    isGlobal: false,
    isHomepage: false
  });

  useEffect(() => {
    setProduct({
      isNomadHealth: getCurrentProduct(location) === 'nomad-health',
      isNomadInsurance: getCurrentProduct(location) === 'nomad-insurance',
      isGlobal: getCurrentProduct(location) === 'global',
      isHomepage: homepage(location),
      isFaqPage: faqPage(location)
    });
  }, [location]);

  const { isNomadHealth, isNomadInsurance, isGlobal, isHomepage, isFaqPage } = product;

  return {
    isNomadHealth,
    isNomadInsurance,
    isGlobal,
    isHomepage,
    isFaqPage
  };
};

export default useLocationChange;
